<div class="flex align-items-center gap-2">
  <i class="{{icons}}"></i>
  <span class="vertical-align-middle">{{title}}</span>
</div>
